var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61719 3.27242V0.817871H4.25355V3.27242C4.25355 5.98363 6.45143 8.18151 9.16264 8.18151C11.8739 8.18151 14.0717 5.98363 14.0717 3.27242V0.817871H15.7081V3.27242C15.7081 5.7368 14.3462 7.88309 12.3339 8.99969C14.3462 10.1163 15.7081 12.2626 15.7081 14.727V17.1815H14.0717V14.727C14.0717 12.0157 11.8739 9.81787 9.16264 9.81787C6.45143 9.81787 4.25355 12.0157 4.25355 14.727V17.1815H2.61719V14.727C2.61719 12.2626 3.97911 10.1163 5.99136 8.99969C3.97911 7.88309 2.61719 5.7368 2.61719 3.27242Z",
    fill: "#FFAA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16335 7.36341C10.547 7.36341 11.7598 6.7089 12.4361 5.72705H5.89062C6.56686 6.7089 7.77967 7.36341 9.16335 7.36341Z",
    fill: "#FFAA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80078 0.818182C1.80078 0.366312 2.16709 0 2.61896 0H15.7099C16.1617 0 16.5281 0.366312 16.5281 0.818182C16.5281 1.27005 16.1617 1.63636 15.7099 1.63636H2.61896C2.16709 1.63636 1.80078 1.27005 1.80078 0.818182ZM1.80078 17.1818C1.80078 16.7299 2.16709 16.3636 2.61896 16.3636H15.7099C16.1617 16.3636 16.5281 16.7299 16.5281 17.1818C16.5281 17.6337 16.1617 18 15.7099 18H2.61896C2.16709 18 1.80078 17.6337 1.80078 17.1818Z",
    fill: "#FFAA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07031 15.5451C5.07031 14.6413 5.80294 13.9087 6.70668 13.9087H11.6158C12.5195 13.9087 13.2521 14.6413 13.2521 15.5451H5.07031Z",
    fill: "#FFAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPending);
export default __webpack_public_path__ + "static/media/iconPending.775c8acd8a1731eeed3c0d2d52d2c5e4.svg";
export { ForwardRef as ReactComponent };